<nav aria-label="breadcrumb">
  <ul class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs">
      <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
    </li>
  </ul>
</nav>
